<div class="container">
  <button id="back-button" class="back-button" (click)="backClicked()">
    <span class="glyph-chevron-previous margin-right-xsmall"></span>
    <span>Back</span>
  </button>
  <br>
  <div class="margin-top-medium standard-name">
    {{ selectedStandard?.standardName }}
  </div>
  <h2 class="standard-description"> {{ selectedStandard?.standardDescription?.trim() }} </h2>
  <div *ngIf="isLoading$ | async">
    <mat-spinner diameter="60" mode="indeterminate" class="mat-spinner skills-spinner"></mat-spinner>
  </div>
  <div class="standard-detail">
    <span *ngIf="!(isLoading$ | async)">
      <div class="context-selector">
        <context-selector [showSubjectDropdown]="false"></context-selector>
      </div>
      <app-scope-sequence-tabs (tabChanged)="updateSelectedTab($event)"></app-scope-sequence-tabs>
      <hr class="no-margin">

      <core-concepts *ngIf="isCoreSelected()" [selectedStandard]="selectedStandard!" [skills]="skills"></core-concepts>
      <prerequisite-skills-plan *ngIf="isPrerequisiteSelected()"></prerequisite-skills-plan>
      <enrichment-pathway *ngIf="isEnrichmentSelected()"></enrichment-pathway>
    </span>
  </div>
</div>
<app-footer></app-footer>
